import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register h-full" }
const _hoisted_2 = { class: "grid grid-cols-9 place-content-center h-full" }
const _hoisted_3 = { class: "col-span-9 md:col-start-3 md:col-span-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-xl font-medium mb-1" }, "Register", -1)
const _hoisted_5 = { class: "onboarding-card" }
const _hoisted_6 = { class: "w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfoForm = _resolveComponent("UserInfoForm")!
  const _component_CompanyInfoForm = _resolveComponent("CompanyInfoForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.userCompleted && _ctx.userData)
              ? (_openBlock(), _createBlock(_component_UserInfoForm, {
                  key: 0,
                  userData: _ctx.userData,
                  captchaRequired: Boolean(_ctx.inviteToken),
                  onUserSubmitted: _ctx.userSubmitted
                }, null, 8, ["userData", "captchaRequired", "onUserSubmitted"]))
              : _createCommentVNode("", true),
            (_ctx.userCompleted)
              ? (_openBlock(), _createBlock(_component_CompanyInfoForm, {
                  key: 1,
                  companyData: _ctx.companyData,
                  onCompanySubmitted: _ctx.companySubmitted,
                  loading: _ctx.loading
                }, null, 8, ["companyData", "onCompanySubmitted", "loading"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}